<template>
  <div class="indexContain" id="HPIndex">
    <div class="indexHeader">
      <IndexHeader></IndexHeader>
    </div>
    <div class="indexInfo">
      <div class="progress">
        <div class="indexIcon"></div>
        <div class="indexTitle">
          今日工程进度
          <div class="effect"></div>
        </div>

        <div class="infoShow">
          <div class="iconImg_1 icon_1"></div>
          <div class="iconImg_2 icon_2"></div>
          <div class="iconImg_3 icon_3"></div>
          <div class="text_1">
            <span class="textBig">{{ projectProcessData.process ?(projectProcessData.process* 100).toFixed(2):'' }}</span>
            <span class="textLow">%</span>
          </div>
          <div class="text_2">
            <span class="textBig" v-if="projectProcessData.meanArea||projectProcessData.mileage">{{workType > 2 ? projectProcessData.meanMileage : (projectProcessData.meanArea*1).toFixed(1) }}</span>
            <span class="textLow">{{workType > 2 ? 'km':'㎡'}}</span>
          </div>
          <div class="text_3">
            <span class="textBig" v-if="projectProcessData.area||projectProcessData.mileage">{{workType > 2 ?  projectProcessData.mileage : (projectProcessData.area*1).toFixed(1) }}</span>
            <span class="textLow">{{workType > 2 ? 'km':'㎡'}}</span>
          </div>
          <div class="title_1">工程进度</div>
          <div class="title_2">日均</div>
          <div class="title_3">今日</div>
        </div>
        <div class="progressChart" id="progressChart"></div>
      </div>
      <div class="mileage">
        <div class="indexIcon"></div>
        <div class="indexTitle">
          作业状态
          <div class="effect"></div>
        </div>
        <div class="infoShow">
          <div class="iconImg_1 icon_1"></div>
          <div class="iconImg_2 icon_2"></div>
          <div class="iconImg_3 icon_3"></div>
          <div class="text_1">
            <span class="textBig">{{ workStatusData.totalNum }}</span>
            <span class="textLow">个</span>
          </div>
          <div class="text_2">
            <span class="textBig">{{ workStatusData.finishedNum }}</span>
            <span class="textLow">个</span>
          </div>
          <div class="text_3">
            <span class="textBig">{{ workStatusData.constructingNum }}</span>
            <span class="textLow">个</span>
          </div>
          <div class="title_1">总作业数</div>
          <div class="title_2">已完成作业</div>
          <div class="title_3">正在施工</div>
        </div>
        <div class="workStatusChart" id="workStatusChart"></div>
      </div>
      <div class="projectTime">
        <div class="indexIcon"></div>
        <div class="indexTitle">
          施工时长(H)
          <div class="effect"></div>
        </div>

        <div class="infoShow">
          <div class="iconImg_1 icon_1"></div>
          <div class="iconImg_2 icon_2"></div>
          <div class="iconImg_3 icon_3"></div>
          <div class="text_1">
            <span class="textBig">{{ workTimeData.workTime }}</span>
            <span class="textLow">H</span>
          </div>
          <div class="text_2">
            <span class="textBig">{{ workTimeData.totalDateVal }}</span>
            <span class="textLow">天</span>
          </div>
          <div class="text_3">
            <span class="textBig">{{
              workTimeData.reduceDate?(workTimeData.reduceDate > 0 ? workTimeData.reduceDate : workTimeData.reduceDate * -1):''
            }}</span>
            <span class="textLow">天</span>
          </div>
          <div class="title_1">今日</div>
          <div class="title_2">已施工时长</div>
          <div class="title_3">
            {{ workTimeData.reduceDate > 0 ? "距离结束还有" : "超时" }}
          </div>
        </div>
        <div class="workTimeChart" id="workTimeChart"></div>
      </div>
      <div class="workTime">
        <div class="indexIcon"></div>
        <div class="indexTitle">
          累计施工时长
          <div class="effect"></div>
        </div>
        <div class="infoShow">
          <div class="iconImg_1 icon_1"></div>
          <div class="iconImg_2 icon_2"></div>
          <div class="iconImg_3 icon_3"></div>
          <div class="text_1">
            <span class="textBig">{{ workAddUpTimeData.finishedNum }}</span>
            <span class="textLow">个</span>
          </div>
          <div class="text_2">
            <span class="textBig">{{ workAddUpTimeData.onTimeNum }}</span>
            <span class="textLow">个</span>
          </div>
          <div class="text_3">
            <span class="textBig">{{
              workAddUpTimeData.delayFinishedNum
            }}</span>
            <span class="textLow">个</span>
          </div>
          <div class="title_1">已完成</div>
          <div class="title_2">按时完成</div>
          <div class="title_3">超时完成</div>
        </div>
        <div class="workAddUpTimeChart" id="workAddUpTimeChart"></div>
      </div>
      <div class="roadInfo">
        <div class="itemInfo">
          <div class="indexIcon"></div>
          <div class="indexTitle">
            压实度
            <div class="effect"></div>
          </div>
          <div class="icvChart" id="icvChart"></div>
        </div>
        <div class="itemInfo">
          <div class="indexIcon"></div>
          <div class="indexTitle">
            摊铺温度
            <div class="effect"></div>
          </div>
          <div class="tempChart" id="tempChart"></div>
        </div>
      </div>
      <div class="mapInfo">
        <baidu-map
          class="bm-view"
          ak="9gINxszg1iVzzxxULmjBLizVXHAWO1Xc"
          :scroll-wheel-zoom="true"
          :zoom="17"
          v-show="choose1 == 1 || initingdMap"
          :dragging="true"
          :center="center"
          @ready="handler"
        >
          <bm-marker :position="center" :dragging="false">
            <bm-label
              :content="labelContent"
              :offset="{ width: -35, height: 30 }"
            />
          </bm-marker>
          <bm-polygon :path="polygonPath" fill-color="#E96B5A" stroke-color="#E96B5A" :stroke-opacity="1" :stroke-weight="2"  />
        </baidu-map>
        <heatMap
          id="centralChart"
          v-show="choose1 != 1"
          :chartOption="chartOptionV"
          :contentShow = "false"
          ref="heatmap"
        />
        <RollLegend
          class="rollLegend"
          v-show="legendImgClass == 1"
          fontColor="white"
          legendType="1"
          ref="rollLegend"
        ></RollLegend>
        <RollLegend
          class="rollLegend"
          v-show="legendImgClass == 2"
          fontColor="white"
          legendType="2"
        ></RollLegend>
        <div class="centralControl" :class="{ ShrinkClass: !expandCtrl }">
          <div
            class="controlItem"
            v-show="expandCtrl && Math.abs(1 - cursor) <= 1.5"
            @click="chooseThisController(1)"
          >
            <div class="title">{{ currentWork.name }}总览</div>
            <div class="blueCover" v-show="choose1 != 1"></div>
          </div>
          <div
            :class="`controlItem controlItem${i % 2}`"
            v-show="expandCtrl && Math.abs(i + 2 - cursor) <= 1.5"
            v-for="(val, i) in works"
            :key="i"
            @click="chooseThisController(i + 2, val.id)"
          >
            <div class="title">
              {{ val.name + " " + (i % 2 == 0 ? "碾压遍数" : "压实度") }}
            </div>
            <div class="blueCover" v-show="choose1 != i + 2"></div>
          </div>
          <div class="bottomShrink" @click="expandCtrl = !expandCtrl">
            <i :class="expandClass"></i>
          </div>
        </div>

        <div class="proName">{{ projectName }} &nbsp;&nbsp; {{currentWork.name==projectName?"":currentWork.name}}</div>
        <div class="changePro" @click="changePro">切换工程 作业</div>
      </div>
    </div>
    <el-dialog title="切换工程、作业" :visible.sync="dialogTableVisible">
      <el-table
        @row-click="chooseProject"
        :data="projList"
        class="centralTable projectTable"
        :row-class-name="projectRowClassName"
      >
        <el-table-column prop="name" label="工程"></el-table-column>
      </el-table>
      <el-table
        @row-click="chooseWork"
        :data="tempWorkList"
        class="centralTable workTable"
        :row-class-name="workClassName"
      >
        <el-table-column prop="name" label="作业"></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveAvtiveProjectSetting"
          >保存</el-button
        >
        <el-button @click="closeProjectBox">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import BaiduMap from "vue-baidu-map/components/map/Map.vue";
import BmMarker from "vue-baidu-map/components/overlays/Marker.vue";
import BmPolygon from "vue-baidu-map/components/overlays/Polygon.vue"
import BmLabel from "vue-baidu-map/components/overlays/Label.vue";
import IndexHeader from "../components/common/indexHeader";
import RollLegend from "../pages/quality/part/rollLegend";
import { unique } from "../utils/commons";
import heatMap from "../components/chart/heatMap";
import {
  getWorks,
  getWorkInfo,
  getProjectProcess,
  getProjectWorkTime,
  rollingQualityTimes,
  rollingQualityIcv,
  getProjectWorkStatus,
  getProjectworkAddUpTime,
  getIcvAndTemperature,
  getProjectActivate,
  getEnginList,
  activeEngin,
  getRoadSectionPointer,
} from "../utils/api";
export default {
  name: "app",
  data() {
    return {
      dialogTableVisible: false,
      projList: [],
      projectId: 14,
      workId: null,
      labelContent: "",
      projectName: "",
      projectProcessData: {},
      legendVisble: false,
      workStatusData: {},
      map: {},
      myGeo: {},
      legendImgClass: 0,
      initingdMap: true,
      initedProject: false,
      workTimeData: {},
      address: "111",
      getProjectWorkTime: {},
      workAddUpTimeData: {},
      progressChart: "",
      cursor: 2.5,
      workStatusChart: "",
      works: [],
      workList: [],
      workType:2,
      workTimeChart: "",
      workAddUpTimeChart: "",
      icvChart: "",
      chartOption: [],
      chartOptionV: {},
      choose1: 2,
      currentWork : {name:"初始化中"},
      expandCtrl: false,
      polygonPath:[],
      center: {
        lng: 113.122845,
        lat: 28.246204,
      },
      local: null,
      tempWorkId: null,
      tempProjectId: "",
      tempWorkList: [],
      rowIndex: 0,
    };
  },
  beforeCreate(){
    
  },
  computed: {
    expandClass: function () {
      if (this.expandCtrl) {
        return "el-icon-arrow-down";
      } else {
        return "el-icon-arrow-up";
      }
    },
  },
  mounted() {
    getProjectActivate().then((res) => {
      if(res.data.content != null){
        this.projectId = res.data.content.info.id || '';
        this.tempProjectId = res.data.content.info.id;
        this.projectName = res.data.content.info.name;
        this.address = res.data.content.info.address;
        this.location = res.data.content.info.location;
        this.initedProject = true;
        getWorks({projectId: this.projectId}).then((res) => {
          this.workType  = res.data.content.info.list[0].workType;
          this.getIndexInfo();
        });
      }else{
        this.$message({
            message: "无绑定工程",
            type: "warning",
          });
      }
      
      
    });
  },
  methods: {
    saveAvtiveProjectSetting() {
      this.dialogTableVisible = false;
      this.workId = this.tempWorkId;
      this.chartOption = [];
      this.chartOptionV = {};
      this.workList = this.tempWorkList;
      this.polygonPath = [];
      this.currentWork = {name:"初始化中"};
      if (this.projectId == this.tempProjectId) {
        //仅切换作业
        this.updateWork();
      } else {
        //切换工程
        this.toActive(this.tempProjectId);
      }
      this.projectId = this.tempProjectId;
      this.legendVisble = false;
      this.legendImgClass = 0;
      this.choose1 = 1;
      this.expandCtrl = true;
    },
    chooseProject(row) {
      this.tempProjectId = row.id;

      let params = {
        projectId: row.id,
      };

      let that = this;
      getWorks(params).then((res) => {
        that.tempWorkList = res.data.content.info.list;
        if (
          that.tempWorkList != null &&
          that.tempWorkList != undefined &&
          that.tempWorkList.length > 0
        ) {
          that.tempWorkId = that.tempWorkList[0].id;
        }else{
          that.tempWorkId  = null;
        }
      });
    },
    chooseWork(row) {
      this.tempWorkId = row.id;
    },
    projectRowClassName({ row, rowIndex }) {
      this.rowIndex = rowIndex;
      if (row.id == this.tempProjectId) {
        return "warning-row";
      }
      return "";
    },
    workClassName({ row, rowIndex }) {
      this.rowIndex = rowIndex;
      if (row.id == this.tempWorkId) {
        return "warning-row";
      }
      return "";
    },
    initMapMarker() {
      var that = this;
      if (that.location) {
        //有直接的位置的话 用直接的位置
        let locArr = that.location.split(",");
        that.center = {
          lng: locArr[0],
          lat: locArr[1],
        };
      } else {
        that.local.search(this.address);
      }
      if(this.currentWork.sectionId==null||this.currentWork.sectionId==undefined){
        this.polygonPath = [];
        return ;
      }
      //更新工程作业道路显示
      let params = {
          sectionId: this.currentWork.sectionId,
          type: 1,
      }

      getRoadSectionPointer(params).then((res) => {
        let dataMap = res.data.content.dataMap;
        let leftLine = dataMap.leftLine;
        let rightLine = dataMap.rightLine;

        let pointArray = new Array();

        for (let value of leftLine) {
          if(value.longitude==null||value.latitude==null){
              continue;
          }
          let point = {
            lng:value.longitude,lat:value.latitude
          }
          pointArray.push(point);
        }

        rightLine = rightLine.reverse();

        for (let value of rightLine) {
          let point = {
            lng:value.longitude,lat:value.latitude
          }
          pointArray.push(point);
        }
        that.polygonPath = pointArray;

        let firstPoint = leftLine[Math.round((leftLine.length-1)/2)];
        if(firstPoint.longitude!=null&&firstPoint.latitude!=null){
           that.center = {
          lng: firstPoint.longitude,
          lat: firstPoint.latitude,
        };
        }
      });
      this.labelContent = this.address;

    },
    handler({ BMap, map }) {
      this.myGeo = new BMap.Geocoder();

      this.map = map;

      this.initingdMap = false;

      let that = this;
      let options = {
        onSearchComplete: function (results) {
          let Hr = results.Hr;
          if (Hr.length == 0) {
            that.$notify.warn({
              title: "错误",
              message: "工程地址信息有误",
            });
          } else {
            let point = Hr[0].point;
            that.center = {
              lng: point.lng,
              lat: point.lat,
            };
          }
          that.labelContent = that.address;

        },
      };

      let local = new BMap.LocalSearch(map, options);
      this.local = local;
      if (this.initedProject) {
        this.initMapMarker();
      }

      var geolocation = new BMap.Geolocation();

      geolocation.getCurrentPosition(
        function (r) {
          if (this.getStatus() == 0) {
            let address = r.address.city;
            window.localStorage.setItem("LJSZH_ADDRESS", address);
          } else {
            console.log("获取地理位置失败");
          }
        },
        { enableHighAccuracy: true }
      );
    },
    closeProjectBox() {
      this.dialogTableVisible = false;
      this.tempWorkId = this.workId;
      this.tempProjectId = this.projectId;
      this.tempWorkList = this.workList;
    },
    initFirstChart(workId) {
      let that = this;

      let params1 = {
        id: workId,
      };
      getWorkInfo(params1).then((res) => {
        var params2 = {
          workId: workId,
        };
        let roadWidth = res.data.content.info.roadWidth;
        let deviationUnit = res.data.content.info.deviationUnit;
        let setRoadWidth = [];
        let code = deviationUnit;
        for (let i = 0; i <= 100; i++) {
          if (i * code <= roadWidth * 1 + code * 1) {
            setRoadWidth.push((code * 10 * i) / 10);
          }
        }
        this.$store.commit("setRoadWidth", setRoadWidth);
        this.$store.commit("deviationUnit", deviationUnit);
        console.log(this.$store.state.roadWidth, "roadWidth");

        rollingQualityTimes(params2).then((res) => {
          that.getData1(res.data.content.info, 0);
          that.chartOptionV = that.chartOption[0];
          // debugger
          // this.choose1 = 1;
          this.legendImgClass = 0;
          this.expandCtrl = true;
        });
      });
    },
    toActive(setId) {
      let params = {
        id: setId,
      };
      let that = this;
      activeEngin(params).then(() => {
        that.getProjectList();
        getProjectActivate().then((res) => {
          that.projectId = res.data.content.info.id;
          that.projectName = res.data.content.info.name;
          that.address = res.data.content.info.address;
          that.location = res.data.content.info.location;
          that.legendImgClass = 0;
          getWorks({projectId: this.projectId}).then((res) => {
            this.workType  = res.data.content.info.list[0].workType;
            this.getIndexInfo();
          });
        });
      });
    },
    getProjectList() {
      getEnginList({ pageSize: 100 }, { listKey: "list" }).then((res) => {
        this.projList = res.data.content.info.list;
      });
    },
    changePro: function () {
      this.dialogTableVisible = true;
      this.getProjectList();
    },
    updateWork() {
      let workArray = new Array();
      for (let i = 0; i < this.workList.length; i++) {
        if (this.workList[i].id == this.workId) {
          workArray.push(this.workList[i]);
          workArray.push(this.workList[i]);
          this.currentWork = this.workList[i];
          break;
        }
      }
      this.initMapMarker();
      this.works = workArray;

      // this.initFirstChart(this.workId);
    },
    toLogin() {
      this.$router.push({ name: "Login" });
    },
    toTransfer() {
      this.$router.push({ name: "Transfer" });
    },
    chooseThisController(item, id) {
      var params = {
        workId: id,
      };
      this.choose1 = item;
      var that = this;
      if (item > 1) {
        this.legendVisble = true;
        if (item % 2 == 0) {
          //第一种图
          if (
            this.chartOption[item - 2] == undefined ||
            this.chartOption[item - 2] == null ||
            this.chartOption[item - 2] == {}
          ) {
            rollingQualityTimes(params).then((res) => {
              if (res.data.content != null && res.data.content != undefined) {
                that.getData1(res.data.content.info, item - 2);
              }
              that.chartOptionV = that.chartOption[item - 2];
              // that.chartOptionV = {};
            });
          } else {
            that.chartOptionV = that.chartOption[item - 2];
            setTimeout(()=>{
              that.$refs.heatmap.myChart.resize()
            },1)
          }
          this.legendImgClass = 1;
        } else if (item % 2 == 1) {
          //第二种图
          if (
            this.chartOption[item - 2] == undefined ||
            this.chartOption[item - 2] == null ||
            this.chartOption[item - 2] == {}
          ) {
            setTimeout(()=>{
              that.$refs.heatmap.myChart.clear()
                that.$refs.heatmap.myChart.resize()
              },1)
            rollingQualityIcv(params).then((res) => {
              if (res.data.content != null && res.data.content != undefined) {
                that.getData2(res.data.content.info, item - 2);
                // that.chartOptionV = {};
                
              }
              that.chartOptionV = that.chartOption[item - 2];
            });
          } else {
            that.chartOptionV = that.chartOption[item - 2];
            setTimeout(()=>{
              that.$refs.heatmap.myChart.resize()
            },1)
          }

          this.legendImgClass = 2;
          
        }
      } else {
        this.legendImgClass = 0;
        this.legendVisble = false;
      }
    },
    getIndexInfo() {
      this.$parent.initRollParameter(this.projectId);
    
      let params = {
        projectId: this.projectId,
      };
      const echarts = require("echarts");

      getProjectProcess(params).then((res) => {
        let getData = res.data.content.info;
        this.projectProcessData = getData;
        console.log(this.workType)
        this.progressChart = echarts.init(
          document.getElementById("progressChart")
        );
        let startVal = 100 - (7 / getData.data.length) * 100;
        const xAxisList = getData.data.map((item) => item.name);
        const series = [
          {
            name: this.workType>2?"每日作业里程":"每日作业面积",
            type: "bar",
            barWidth: 10,
            data: getData.data.map((item) => {
              return item.values[0];
            }),
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#265DFD",
                  },
                  {
                    offset: 1,
                    color: "#0492FF",
                  },
                ]),
              },
            },
          },
          {
            name: "工程进度",
            type: "line",
            yAxisIndex: 1,
            data: getData.data.map((item) => {
              return (item.values[1] * 100).toFixed(2);
            }),
            itemStyle: {
              normal: {
                color: "#F6C021",
              },
            },
          },
        ];
        let option = {
          legend: {
            data: [this.workType>2?"每日作业里程":"每日作业面积", "工程进度"],
            textStyle: {
              color: "#fff",
              fontSize: 12,
            },
            top: 14,
            right: 10,
            itemHeight: 10,
            itemWidth: 10,
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
              crossStyle: {
                color: "#999",
              },
            },
          },
          grid: {
            left: 50,
            right: 60,
            top: 50,
            bottom: 40,
          },
          xAxis: [
            {
              type: "category",
              data: xAxisList,
              splitLine: {
                show: false,
              },
              axisLabel: {
                color: "#ffffff",
                fontSize: 10,
              },
              axisLine: {
                lineStyle: {
                  color: "#194793",
                },
              },
              axisTick: {
                show: false,
              },
            },
          ],
          yAxis: [
            {
              type: "value",
              name: this.workType>2?"(km)":"(㎡)",
              nameTextStyle: {
                color: "#ffffff",
                fontSize: 10,
              },
              // interval: '',
              splitLine: {
                show: true,
                lineStyle: {
                  color: ["#194793"],
                },
              },
              axisLabel: {
                color: "#ffffff",
                fontSize: 10,
              },
              axisLine: {
                show: false,
                lineStyle: {
                  color: "#878787",
                },
              },
              axisTick: {
                show: false,
              },
            },
            {
              type: "value",
              name: "",
              min: 0,
              max: 100,
              // interval: 25,
              splitLine: {
                show: false,
              },
              axisLabel: {
                color: "#ffffff",
                fontSize: 10,
                formatter: "{value} %",
              },
              axisLine: {
                show: false,
                lineStyle: {
                  color: "#878787",
                },
              },
              axisTick: {
                show: false,
              },
            },
          ],
          dataZoom: [
            {
              type: "slider",
              show: true,
              realtime: true,
              start: startVal,
              end: 100,
              handleSize: "10%",
              height: 10,
              handleStyle: {
                borderWidth: 2,
              },
              bottom: "0",
              borderColor: "#0492FF",
              fillerColor: "#265DFD",
            },
            {
              type: "inside",
              xAxisIndex: [0],
            },
            {
              type: "slider",
              yAxisIndex: [0],
              show: false,
              zoomLock: true,
            },
          ],
          series: series,
        };
        this.progressChart.setOption(option);
      });

      getProjectWorkTime(params).then((res) => {
        let getData = res.data.content.info;
        this.workTimeData = res.data.content.info;
        let getList = res.data.content.info.data;
        this.workTimeData.totalDateVal = getList.length;
        let planEndTime = Date.parse(
          new Date(res.data.content.info.planEndTime)
        );
        let nowDate = Date.parse(new Date());
        let reduceDate = Math.ceil(
          (planEndTime * 1 - nowDate * 1) / (3600 * 24 * 1000)
        );
        this.workTimeData.reduceDate = reduceDate;
        this.workTimeChart = echarts.init(
          document.getElementById("workTimeChart")
        );
        let startVal = 100 - (7 / getData.data.length) * 100;
        const xAxisList = getData.data.map((item) => item.name);
        const series = [
          {
            name: "施工时长",
            type: "bar",
            barWidth: 10,
            data: getData.data.map((item) => {
              return item.values[0].toFixed(1);
            }),
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#265DFD",
                  },
                  {
                    offset: 1,
                    color: "#0492FF",
                  },
                ]),
              },
            },
          },
        ];
        let option = {
          legend: {
            data: ["施工时长"],
            textStyle: {
              color: "#fff",
              fontSize: 12,
            },
            top: 14,
            right: 10,
            itemHeight: 10,
            itemWidth: 10,
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
              crossStyle: {
                color: "#999",
              },
            },
          },
          grid: {
            left: 50,
            right: 40,
            top: 50,
            bottom: 40,
          },
          xAxis: [
            {
              type: "category",
              data: xAxisList,
              splitLine: {
                show: false,
              },
              axisLabel: {
                color: "#ffffff",
                fontSize: 10,
              },
              axisLine: {
                lineStyle: {
                  color: "#194793",
                },
              },
              axisTick: {
                show: false,
              },
            },
          ],
          yAxis: [
            {
              type: "value",
              name: "(H)",
              nameTextStyle: {
                color: "#ffffff",
                fontSize: 10,
              },
              // interval: '',
              splitLine: {
                show: true,
                lineStyle: {
                  color: ["#194793"],
                },
              },
              axisLabel: {
                color: "#ffffff",
                fontSize: 10,
              },
              axisLine: {
                show: false,
                lineStyle: {
                  color: "#878787",
                },
              },
              axisTick: {
                show: false,
              },
            },
          ],
          dataZoom: [
            {
              type: "slider",
              show: true,
              realtime: true,
              start: startVal,
              end: 100,
              handleSize: "10%",
              height: 10,
              handleStyle: {
                borderWidth: 2,
              },
              bottom: "0",
              borderColor: "#0492FF",
              fillerColor: "#265DFD",
            },
            {
              type: "inside",
              xAxisIndex: [0],
            },
            {
              type: "slider",
              yAxisIndex: [0],
              show: false,
              zoomLock: true,
            },
          ],
          series: series,
        };
        this.workTimeChart.setOption(option);
      });

      getProjectWorkStatus(params).then((res) => {
        let getData = res.data.content.info;
        this.workStatusData = res.data.content.info;
        this.workStatusChart = echarts.init(
          document.getElementById("workStatusChart")
        );
        const yAxisList = getData.subData.map((item) => item.workName);
        const statusArr = getData.subData.map((item) => item.workStatus);
        const series = [
          {
            name: "",
            type: "bar",
            barWidth: 10,
            data: getData.subData.map((item) => {
              return item.percentage * 100;
            }),
            itemStyle: {
              normal: {
                color: function (params) {
                  let colorList = [
                    new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                      {
                        offset: 0,
                        color: "#D4893F",
                      },
                      {
                        offset: 1,
                        color: "#F9A562",
                      },
                    ]),
                    new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                      {
                        offset: 0,
                        color: "#3156CF",
                      },
                      {
                        offset: 1,
                        color: "#7650FB",
                      },
                    ]),
                    new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                      {
                        offset: 0,
                        color: "#265DFD",
                      },
                      {
                        offset: 1,
                        color: "#0492FF",
                      },
                    ]),
                  ];
                  return colorList[statusArr[params.dataIndex]];
                },
              },
            },
          },
        ];
        let option = {
          legend: {
            data: ["已完成"],
            textStyle: {
              color: "#fff",
              fontSize: 12,
            },
            top: 14,
            right: 10,
            itemHeight: 10,
            itemWidth: 10,
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
              crossStyle: {
                color: "#999",
              },
            },
            formatter: function (params) {
              let status = "";
              if (statusArr[params[0].dataIndex] == 0) {
                status = "未完成";
              } else if (statusArr[params[0].dataIndex] == 1) {
                status = "作业中";
              } else if (statusArr[params[0].dataIndex] == 2) {
                status = "已完成";
              }
              let str = params[0].name + "</br>";
              str = str + "作业进度:" + (params[0].data).toFixed(2) + "%" + "</br>";
              str = str + "作业状态:" + status;
              return str;
            },
          },
          grid: {
            left: 0,
            right: 40,
            top: 40,
            bottom: 40,
            containLabel: true
          },
          xAxis: {
            type: "value",
            name: "(%)",
            splitLine: {
              show: false,
            },
            axisLabel: {
              color: "#ffffff",
              fontSize: 10,
              formatter: function (value) {
                return value + "%";
              },
            },
            axisLine: {
              lineStyle: {
                color: "#194793",
              },
            },
            axisTick: {
              show: false,
            },
            position: "top",
          },

          yAxis: {
            type: "category",

            nameTextStyle: {
              color: "#ffffff",
              fontSize: 10,
            },
            // interval: '',
            splitLine: {
              show: false,
              lineStyle: {
                color: ["#194793"],
              },
            },
            axisLabel: {
              color: "#ffffff",
              fontSize: 10,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#194793",
              },
            },
            axisTick: {
              show: false,
            },
            data: yAxisList,
          },
          series: series,
        };
        this.workStatusChart.setOption(option);
      });

      getProjectworkAddUpTime(params).then((res) => {
        let getData = res.data.content.info;
        this.workAddUpTimeData = res.data.content.info;
        this.workAddUpTimeChart = echarts.init(
          document.getElementById("workAddUpTimeChart")
        );
        const yAxisList = getData.subData.map((item) => item.workName);
        const statusArr = getData.subData.map((item) => item.workStatus);
        const series = [
          {
            name: "",
            type: "bar",
            barWidth: 10,
            data: getData.subData.map((item) => {
              return item.workTime;
            }),
            itemStyle: {
              normal: {
                color: function (params) {
                  // console.log(params, "params");
                  let colorList = [
                    new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                      {
                        offset: 0,
                        color: "#D4893F",
                      },
                      {
                        offset: 1,
                        color: "#F9A562",
                      },
                    ]),
                    new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                      {
                        offset: 0,
                        color: "#3156CF",
                      },
                      {
                        offset: 1,
                        color: "#7650FB",
                      },
                    ]),
                    new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                      {
                        offset: 0,
                        color: "#0492FF",
                      },
                      {
                        offset: 1,
                        color: "#265DFD",
                      },
                    ]),
                  ];
                  return colorList[statusArr[params.dataIndex]];
                },
              },
            },
          },
        ];
        let option = {
          legend: {
            data: ["已完成"],
            textStyle: {
              color: "#fff",
              fontSize: 12,
            },
            top: 14,
            right: 10,
            itemHeight: 10,
            itemWidth: 10,
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
              crossStyle: {
                color: "#999",
              },
            },
            formatter: function (params) {
              let status = "";
              if (statusArr[params[0].dataIndex] == 0) {
                status = "未完成";
              } else if (statusArr[params[0].dataIndex] == 1) {
                status = "超时完成";
              } else if (statusArr[params[0].dataIndex] == 2) {
                status = "按时完成";
              }
              let str = params[0].name + "</br>";
              str = str + "施工时长:" + params[0].data + "H" + "</br>";
              str = str + "完成状态:" + status;
              return str;
            },
          },
          grid: {
            left: 0,
            right: 40,
            top: 40,
            bottom: 40,
            containLabel: true
          },
          xAxis: {
            type: "value",
            name: "(H)",
            splitLine: {
              show: false,
            },
            axisLabel: {
              color: "#ffffff",
              fontSize: 10,
              formatter: function (value) {
                return value + "H";
              },
            },
            axisLine: {
              lineStyle: {
                color: "#194793",
              },
            },
            axisTick: {
              show: false,
            },
            position: "top",
          },

          yAxis: {
            type: "category",

            nameTextStyle: {
              color: "#ffffff",
              fontSize: 10,
            },
            // interval: '',
            splitLine: {
              show: false,
              lineStyle: {
                color: ["#194793"],
              },
            },
            axisLabel: {
              color: "#ffffff",
              fontSize: 10,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#194793",
              },
            },
            axisTick: {
              show: false,
            },
            data: yAxisList,
          },
          series: series,
        };
        this.workAddUpTimeChart.setOption(option);
      });

      getIcvAndTemperature(params).then((res) => {
        let colorList = [
          "#077FFF",
          "#7250F9",
          "#59EAFA",
          "#E2CC80",
          "#F4A460",
          "	#FFFAFA",
        ];
        // icv
        this.icvChart = echarts.init(document.getElementById("icvChart"));
        let getDataIcv = res.data.content.info.icvList;
        let xAxisListIcv = [];
        let resGet = {}
        if(getDataIcv.length>0){
          resGet = getDataIcv[0].timeDataMap;
        }
        for (let key in resGet) {
          xAxisListIcv.push(key);
        }
        xAxisListIcv = xAxisListIcv.sort();
        let seriesIcv = [];
        let legendIcv = [];
        for (let i = 0; i < getDataIcv.length; i++) {
          let yData = [];
          legendIcv.push(getDataIcv[i].equipName);
          for (let j = 0; j < xAxisListIcv.length; j++) {
            yData.push(getDataIcv[i].timeDataMap[xAxisListIcv[j]]);
          }
          let setObj = {
            name: getDataIcv[i].equipName,
            type: "line",
            data: yData,
            symbol: "circle", //折点设定为实心点
            areaStyle: {
              normal: {
                // color: colorList[i], //改变区域颜色
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 1, color: "rgba(0,0,0,0)" },
                  { offset: 0, color: colorList[i] },
                ]),
              },
            },
            itemStyle: {
              normal: {
                color: colorList[i], //改变折线点的颜色
                lineStyle: {
                  color: colorList[i], //改变折线颜色
                },
              },
            },
          };
          seriesIcv.push(setObj);
        }
        let option = {
          legend: {
            data: legendIcv,
            textStyle: {
              color: "#fff",
              fontSize: 12,
            },
            top: 14,
            right: 50,
            itemHeight: 10,
            itemWidth: 10,
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
              crossStyle: {
                color: "#999",
              },
            },
          },
          grid: {
            left: 50,
            right: 60,
            top: 40,
            bottom: 90,
          },
          xAxis: {
            type: "category",
            data: xAxisListIcv,
            splitLine: {
              show: false,
            },
            axisLabel: {
              color: "#ffffff",
              fontSize: 10,
            },
            axisLine: {
              lineStyle: {
                color: "#194793",
              },
            },
            axisTick: {
              show: false,
            },
          },
          yAxis: {
            type: "value",
            name: "",
            nameTextStyle: {
              color: "#ffffff",
              fontSize: 10,
            },
            // interval: '',
            splitLine: {
              show: true,
              lineStyle: {
                color: ["#194793"],
              },
            },
            axisLabel: {
              color: "#ffffff",
              fontSize: 10,
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#878787",
              },
            },
            axisTick: {
              show: false,
            },
          },
          dataZoom: [
            {
              type: "slider",
              show: true,
              realtime: true,
              start: 0,
              end: 100,
              handleSize: "10%",
              height: 10,
              handleStyle: {
                borderWidth: 2,
              },
              bottom: "40",
              borderColor: "#0492FF",
              fillerColor: "#265DFD",
            },
            {
              type: "inside",
              xAxisIndex: [0],
            },
            {
              type: "slider",
              yAxisIndex: [0],
              show: false,
              zoomLock: true,
            },
          ],
          series: seriesIcv,
        };
        this.icvChart.setOption(option);

        // temperature
        this.tempChart = echarts.init(document.getElementById("tempChart"));
        let getDatatemp = res.data.content.info.temperatureList;
        let xAxisListTemp = [];
        let resGetTemp = {}
        if(getDataIcv.length>0){
          resGetTemp = getDatatemp[0].timeDataMap;
        }
        for (let key in resGetTemp) {
          xAxisListTemp.push(key);
        }
        xAxisListTemp = xAxisListTemp.sort();
        let seriesTemp = [];
        let legendTemp = [];
        for (let i = 0; i < getDatatemp.length; i++) {
          let yData = [];
          legendTemp.push(getDatatemp[i].equipName);
          for (let j = 0; j < xAxisListTemp.length; j++) {
            yData.push(getDatatemp[i].timeDataMap[xAxisListTemp[j]]);
          }
          let setObj = {
            name: getDatatemp[i].equipName,
            type: "line",
            data: yData,
            symbol: "circle", //折点设定为实心点
            areaStyle: {
              normal: {
                // color: colorList[i], //改变区域颜色
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 1, color: "rgba(0,0,0,0)" },
                  { offset: 0, color: colorList[i] },
                ]),
              },
            },
            itemStyle: {
              normal: {
                color: colorList[i], //改变折线点的颜色
                lineStyle: {
                  color: colorList[i], //改变折线颜色
                },
              },
            },
          };
          seriesTemp.push(setObj);
        }
        let optionTemp = {
          legend: {
            data: legendTemp,
            textStyle: {
              color: "#fff",
              fontSize: 12,
            },
            top: 14,
            right: 50,
            itemHeight: 10,
            itemWidth: 10,
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
              crossStyle: {
                color: "#999",
              },
            },
          },
          grid: {
            left: 50,
            right: 60,
            top: 40,
            bottom: 90,
          },
          xAxis: {
            type: "category",
            data: xAxisListIcv,
            splitLine: {
              show: false,
            },
            axisLabel: {
              color: "#ffffff",
              fontSize: 10,
            },
            axisLine: {
              lineStyle: {
                color: "#194793",
              },
            },
            axisTick: {
              show: false,
            },
          },
          yAxis: {
            type: "value",
            name: "",
            nameTextStyle: {
              color: "#ffffff",
              fontSize: 10,
            },
            // interval: '',
            splitLine: {
              show: true,
              lineStyle: {
                color: ["#194793"],
              },
            },
            axisLabel: {
              color: "#ffffff",
              fontSize: 10,
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#878787",
              },
            },
            axisTick: {
              show: false,
            },
          },
          dataZoom: [
            {
              type: "slider",
              show: true,
              realtime: true,
              start: 0,
              end: 100,
              handleSize: "10%",
              height: 10,
              handleStyle: {
                borderWidth: 2,
              },
              bottom: "40",
              borderColor: "#0492FF",
              fillerColor: "#265DFD",
            },
            {
              type: "inside",
              xAxisIndex: [0],
            },
            {
              type: "slider",
              yAxisIndex: [0],
              show: false,
              zoomLock: true,
            },
          ],
          series: seriesTemp,
        };
        this.tempChart.setOption(optionTemp);
      });

      this.initCentralChart();
    },
    initCentralChart() {
      this.cursor = 2.5;

      this.legendVisble = false;
      let params = {
        projectId: this.projectId,
      };
      /**
       * 初始化中央视觉映射
       */
      let that = this;
      getWorks(params).then((res) => {
        let newworks = new Array();
        that.works = res.data.content.info.list;
        that.workList = res.data.content.info.list;
        that.workType  = res.data.content.info.list[0].workType;
        console.log(that.workType)
        that.tempWorkList = res.data.content.info.list;
        for (var i in that.works) {
          if (that.works[i].id == that.workId) {
            newworks.push(that.works[i]);
            newworks.push(that.works[i]);
            that.currentWork = that.works[i];
            break;
          } else {
            newworks.push(that.works[0]);
            newworks.push(that.works[0]);
            that.currentWork = that.works[0];
            break;
          }
        }
        if(newworks.length==0){
            //没有
            that.currentWork = {
              name : that.projectName
            }
        }
        that.works = newworks;
        if (that.workId) {
          that.tempWorkId = that.workId;
          that.initFirstChart(that.workId);
        } else if (that.works.length > 0) {
          let workId = that.works[0].id;
          that.workId = workId;
          that.tempWorkId = workId;
          that.initFirstChart(workId);
        }
          this.choose1 = 1;

      if (!this.initingdMap) {
        this.initMapMarker();
      }
      });
    
    },
    getData1(res, index) {
      if (res.data == null || res.data == undefined) {
        return;
      }
      let xAxisObj = {};
      var xAxisData = res.data.map((item) => item[0]);
      // xAxisData.length = 100;
      var yAxisData = this.$store.state.roadWidth;
      xAxisData = unique(xAxisData);
      for (let i = 0; i < xAxisData.length; i++) {
        xAxisObj[xAxisData[i]] = i;
      }
      let data = [];
      const dataMap = {};
      res.data.map((item) => {
        const y = Math.floor(Math.random() * 6);
        dataMap[`${item[0]}_${y}`] = Math.ceil(Math.random() * 20);
      });
      let code = this.$store.state.deviationUnit;
      for (let i = 0; i < res.data.length; i++) {
        let arr = [
          xAxisObj[res.data[i][0]],
          (res.data[i][1] * 10) / (code * 10),
          res.data[i][2].toFixed(0) * 1,
        ];
        data.push(arr);
      }

      // const colorBox =  this.$store.state.rollNumColorArr.reverse();
      const colorBox = JSON.parse(
        JSON.stringify(this.$store.state.rollNumColorArr)
      ).reverse();
      let colorList = this.$store.state.rollNumColor;
      let keys = Object.keys(colorList);
      let setArr = []
      for(let i=0;i<keys.length;i++){
        setArr.push({
          min: keys[i]*1,
          max: keys[i]*1
        })
      }
      setArr[setArr.length-1].max = 200
      this.chartOption[index] = {
        visualMap: {
          type: "piecewise",
          min: 0,
          max: 10,
          calculable: true,
          realtime: false,
          orient: "horizontal",
          left: "center",
          bottom: "15%",
          show: false,
          pieces: setArr,
          color: colorBox,
        },
        tooltip: {
          position: "top",
          formatter: function (a) {
            let str = a.data[2];
            return a.name + ":" + " " + str;
          },
        },
        animation: false,
        grid: {
          height: "70%",
          top: "10%",
        },
        xAxis: {
          type: "category",
          data: xAxisData,
          splitArea: {
            show: true,
          },
          splitLine: {
            show: false,
          },
          axisLabel: {
            color: "#ffffff",
            fontSize: 10,
          },
          axisLine: {
            lineStyle: {
              color: "#194793",
            },
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: {
          type: "category",
          data: yAxisData,
          splitArea: {
            show: false,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: ["#194793"],
            },
          },
          axisLabel: {
            // lineStyle: {
            //   color: "#878787",
            // },
            color: "#ffffff",
            fontSize: 10,
          },
          axisLine: {
            lineStyle: {
              color: "#878787",
            },
          },
          axisTick: {
            show: false,
          },
        },
        series: [
          {
            name: "Punch Card",
            type: "heatmap",
            data: data,
            label: {
              show: false,
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
        dataZoom: [
          {
            type: "slider",
            show: true,
            realtime: true,
            start: 90,
            end: 100,
            handleSize: "10%",
            height: 10,
            handleStyle: {
              borderWidth: 2,
            },
            bottom: "10%",
            borderColor: "#0492FF",
            fillerColor: "#265DFD",
            textStyle: {
              color: "#ffffff",
            },
          },
          {
            type: "inside",
            xAxisIndex: [0],
          },
          {
            type: "slider",
            yAxisIndex: [0],
            show: false,
            zoomLock: true,
          },
        ],
      };
    },
    getData2(res, item) {
      if (res.data == null || res.data == undefined) {
        return;
      }
      let xAxisObj = {};
      var xAxisData = res.data.map((item) => item[0]);
      // xAxisData.length = 100;
      var yAxisData = this.$store.state.roadWidth;
      xAxisData = unique(xAxisData);
      for (let i = 0; i < xAxisData.length; i++) {
        xAxisObj[xAxisData[i]] = i;
      }
      let data = [];
      const dataMap = {};
      res.data.map((item) => {
        const y = Math.floor(Math.random() * 6);
        dataMap[`${item[0]}_${y}`] = Math.ceil(Math.random() * 20);
      });
      let code = this.$store.state.deviationUnit;
      for (let i = 0; i < res.data.length; i++) {
        let arr = [
          xAxisObj[res.data[i][0]],
          (res.data[i][1] * 10) / (code * 10),
          // res.data[i][2]?res.data[i][2].toFixed(0) * 1:null,
          res.data[i][2].toFixed(0) * 1
        ];
        data.push(arr);
      }

      // const colorBox = this.$store.state.icvColorArr.reverse();
      const colorBox = JSON.parse(
        JSON.stringify(this.$store.state.icvColorArr)
      ).reverse();
      let colorList = this.$store.state.icvColor;
      let keys = Object.keys(colorList);
      let setArr = []
      for(let i=0;i<keys.length;i++){
        setArr.push({
          min: keys[i-1]?keys[i-1]*1+1:0,
          max: keys[i]*1
        })
      }
      this.chartOption[item] = {
        visualMap: {
          type: "piecewise",
          min: 0,
          max: 100,
          calculable: true,
          realtime: false,
          orient: "horizontal",
          left: "center",
          bottom: "15%",
          show: false,
          pieces: setArr,
          color: colorBox,
        },
        xAxis: {
          type: "category",
          data: xAxisData,
          splitArea: {
            show: true,
          },
          splitLine: {
            show: false,
          },
          axisLabel: {
            lineStyle: {
              color: "#ffffff",
              fontSize:10
            },
          },
          axisLine: {
            lineStyle: {
              color: "#194793",
            },
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: {
          type: "category",
          data: yAxisData,
          splitArea: {
            show: true,
          },
          splitLine: {
            show: false,
          },
          axisLabel: {
            lineStyle: {
              color: "#878787",
            },
          },
          axisLine: {
            lineStyle: {
              color: "#878787",
            },
          },
          axisTick: {
            show: false,
          },
        },
        series: [
          {
            name: "Punch Card",
            type: "heatmap",
            data: data,
            label: {
              show: false,
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
        dataZoom: [
          {
            type: "slider",
            show: true,
            realtime: true,
            start: 90,
            end: 100,
            handleSize: "10%",
            height: 10,
            handleStyle: {
              borderWidth: 2,
            },
            bottom: "10%",
            borderColor: "#0492FF",
            fillerColor: "#265DFD",
            textStyle: {
              color: "#ffffff",
            },
          },
          {
            type: "inside",
            xAxisIndex: [0],
          },
          {
            type: "slider",
            yAxisIndex: [0],
            show: false,
            zoomLock: true,
          },
        ],
      };
    },
  },
  components: {
    IndexHeader,
    BaiduMap,
    heatMap,
    BmMarker,
    BmLabel,
    RollLegend,
    BmPolygon
  },
};
</script>
<style>
.BMapLabel {
  border: none !important;
  background: transparent !important;
}

#HPIndex .warning-row {
  background: rgba(245, 108, 108, 0.1);
  color: rgb(245, 108, 108);
}
</style>
<style lang="scss" scoped="">
.legendImg {
  height: 60px;
  width: 240px;
  position: absolute;
  z-index: 100;
  top: 14px;
  right: 21px;
  background-size: 100% 100%;
  // background-color: #e1e1e1;
}

.legendImg {
  height: 60px;
  width: 240px;
  position: absolute;
  z-index: 100;
  top: 14px;
  right: 21px;
  background-size: 100% 100%;
  // background-color: #e1e1e1;
}

.cvImg {
  background-image: url("../images/all/icvNum1.png");
  background-size: 100% 100%;
}

.rnImg {
  background-image: url("../images/all/rollNum1.png");
  background-size: 100% 100%;
}
.setProject {
  display: inline-block;
  font-size: 14px;
  color: #555555;
  background: rgba(238, 236, 236, 1);
  border: 1px solid rgba(196, 196, 196, 1);
  border-radius: 16px;
  padding: 4px 16px;
  cursor: pointer;
}
.lookMore {
  display: inline-block;
  font-size: 14px;
  color: #e24747;
  background: rgba(255, 232, 232, 1);
  border: 1px solid rgba(226, 71, 71, 1);
  border-radius: 16px;
  padding: 4px 16px;
  margin-left: 10px;
  cursor: pointer;
}
.indexContain {
  background-image: url("../images/all/indexBG.png");
  background-size: 100% 100%;
  padding-bottom: 17px;
}
.text {
  color: red;
}
.indexHeader {
  width: 100%;
  height: 90px;
}
.indexInfo {
  width: 100%;
  margin-top: 5px;
  position: relative;
  height: 967px;
  .infoShow {
    width: 375px;
    height: 65px;
    position: absolute;
    background-color: rgba(24, 86, 185, 0.7);
    border: 1px solid #2c83c6;
    border-radius: 4px;
    top: 55px;
    left: 50%;
    transform: translateX(-50%);
    .iconImg_1 {
      height: 20px;
      width: 20px;
      position: absolute;
      top: 22px;
      left: 17px;
    }
    .iconImg_2 {
      height: 20px;
      width: 20px;
      position: absolute;
      top: 22px;
      left: 141px;
    }
    .iconImg_3 {
      height: 20px;
      width: 20px;
      position: absolute;
      top: 22px;
      left: 265px;
    }
    .icon_1 {
      background-image: url("../images/icon/icon_1.png");
      background-size: 100% 100%;
    }
    .icon_2 {
      background-image: url("../images/icon/icon_2.png");
      background-size: 100% 100%;
    }
    .icon_3 {
      background-image: url("../images/icon/icon_3.png");
      background-size: 100% 100%;
    }
    .icon_4 {
      background-image: url("../images/icon/icon_4.png");
      background-size: 100% 100%;
    }
    .icon_5 {
      background-image: url("../images/icon/icon_5.png");
      background-size: 100% 100%;
    }
    .text_1 {
      height: 20px;
      position: absolute;
      top: 11px;
      left: 44px;
      color: #56cbf6;
      font-weight: bold;
    }
    .text_2 {
      height: 20px;
      position: absolute;
      top: 11px;
      left: 168px;
      color: #56cbf6;
      font-weight: bold;
    }
    .text_3 {
      height: 20px;
      position: absolute;
      top: 11px;
      left: 293px;
      color: #56cbf6;
      font-weight: bold;
    }
    .textBig {
      font-size: 24px;
    }
    .textLow {
      font-size: 14px;
      margin-left: 3px;
    }
    .title_1 {
      position: absolute;
      height: 13px;
      line-height: 13px;
      color: #ffffff;
      font-size: 13px;
      top: 41px;
      left: 43px;
    }
    .title_2 {
      position: absolute;
      height: 13px;
      line-height: 13px;
      color: #ffffff;
      font-size: 13px;
      top: 41px;
      left: 172px;
    }
    .title_3 {
      position: absolute;
      height: 13px;
      line-height: 13px;
      color: #ffffff;
      font-size: 13px;
      top: 41px;
      left: 293px;
    }
  }
  .indexIcon {
    height: 22px;
    width: 19px;
    position: absolute;
    background-image: url("../images/all/indexIcon.png");
    background-size: 100% 100%;
    top: 15px;
    left: 18px;
  }
  .indexTitle {
    position: absolute;
    height: 16px;
    line-height: 16px;
    color: #ffffff;
    font-size: 16px;
    top: 19px;
    left: 45px;
    .effect {
      display: inline-block;
      width: 138px;
      height: 10px;
      background-image: url("../images/all/effect.png");
      background-size: 100% 100%;
      margin-left: 12px;
    }
  }
  .progress {
    position: absolute;
    top: 0;
    left: 20px;
    width: 420px;
    height: 379px;
    background-image: url("../images/all/indexType_1.png");
    background-size: 100% 100%;
    .progressChart {
      position: absolute;
      width: 100%;
      height: 259px;
      left: 0;
      bottom: 0;
    }
  }
  .projectTime {
    position: absolute;
    top: 0;
    right: 20px;
    width: 420px;
    height: 379px;
    background-image: url("../images/all/indexType_1.png");
    background-size: 100% 100%;
    .workTimeChart {
      position: absolute;
      width: 100%;
      height: 259px;
      left: 0;
      bottom: 0;
    }
  }
  .mileage {
    position: absolute;
    top: 402px;
    left: 20px;
    width: 420px;
    height: 565px;
    background-image: url("../images/all/indexType_2.png");
    background-size: 100% 100%;
    .workStatusChart {
      position: absolute;
      width: 100%;
      height: 440px;
      left: 0;
      bottom: 0;
    }
  }
  .workTime {
    position: absolute;
    top: 402px;
    right: 20px;
    width: 420px;
    height: 565px;
    background-image: url("../images/all/indexType_2.png");
    background-size: 100% 100%;
    .workAddUpTimeChart {
      position: absolute;
      width: 100%;
      height: 440px;
      left: 0;
      bottom: 0;
    }
  }
  .roadInfo {
    position: absolute;
    width: 1005px;
    height: 386px;
    top: 589px;
    left: 50%;
    transform: translateX(-50%);
    background-image: url("../images/all/indexType_3.png");
    background-size: 100% 100%;
    display: flex;
    .itemInfo {
      flex: 1;
      position: relative;
      .icvChart {
        position: absolute;
        width: 100%;
        height: 340px;
        left: 0;
        bottom: 0;
      }
      .tempChart {
        position: absolute;
        width: 100%;
        height: 340px;
        left: 0;
        bottom: 0;
      }
    }
  }
  .mapInfo {
    position: absolute;
    width: 1000px;
    height: 565px;
    background: rgba(11, 67, 160, 0.7);
    border: 1px solid #2d99c3;
    // opacity: 0.7;
    border-radius: 5px;
    top: 0;
    left: calc(50% - 500px);
    .changePro {
      width: 128px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      background: #1c6dfe;
      border-radius: 15px;
      position: absolute;
      right: 24px;
      bottom: 26px;
      color: #caf1f9;
      font-size: 14px;
      cursor: pointer;
    }
    .proName {
      height: 20px;
      line-height: 20px;
      color: #ffffff;
      font-size: 20px;
      font-weight: bold;
      position: absolute;
      left: 23px;
      bottom: 31px;
    }
    .bm-view {
      width: 967px;
      height: 472px;
      position: absolute;
      left: calc(50% - 483.5px);
      top: 12px;
    }
    #centralChart {
      position: absolute;
      width: 1100px;
      height: 450px !important;
      top: 40px;
      // left: -40px;
    }
    .centralControl {
      position: absolute;
      width: calc(100% - 26px);
      height: 105px;
      bottom: 78px;
      padding-top: 5px;
      margin-left: 13px;
      margin-right: 13px;
      background-color: #1e3c98;
      // overflow-x: auto;
      .controlItem {
        cursor: pointer;
        width: 233px;
        display: inline-block;
        height: 98px;
        background-position: center;
        background-repeat: no-repeat;
        background-size: 233px 98px;
        background-repeat: no-repeat;
        background-size: contain;
        background-color: antiquewhite;
        // float: left;
        .title {
          position: absolute;
          bottom: 0px;
          padding-left: 5px;
          height: 32px;
          line-height: 32px;
          background-color: rgba(30, 60, 152, 0.85);
          color: white;
          width: 243px;
          font-size: 16px;
        }
        .blueCover {
          background-color: rgba(30, 60, 152, 0.65);
          position: absolute;
          top: 0px;
          height: 73px;
          width: 243px;
        }
      }
      .controlItem:not(:last-child) {
        margin-right: 9px;
      }
      .controlItem:nth-child(1) {
        background-image: url("../images/controlItem/u55.png");
      }
      .controlItem0 {
        background-image: url("../images/controlItem/rollTimes.png");
        background-position: 0 15px;
      }
      .controlItem1 {
        background-image: url("../images/controlItem/rollIcv.png");
        background-size: 73%;
        background-position: 33px 15px;
      }
      .bottomShrink {
        position: absolute;
        top: -20px;
        width: 96px;
        height: 24px;
        left: calc(50% - 50px);
        background-repeat: no-repeat;
        background-position-x: center;
        background-size: 96px 24px;
        background-image: url(../images/controlItem/shrink.png);
        cursor: pointer;
        i {
          margin-left: calc(50% - 8px);
          color: white;
          margin-top: 5px;
          font-size: 16px;
        }
      }

      .rightArrow {
        right: 15px;
        top: 10px;
      }

      .leftArrow {
        left: 10px;
        top: 10px;
        transform: rotate(180deg);
      }

      .actionArrow {
        cursor: pointer;
        position: absolute;
        height: 90px;
        width: 30px;
        img {
          height: 32px;
          width: 14px;
          top: calc(50% - 16px);
          right: calc(50% - 7px);
          position: absolute;
        }
      }
    }
    .ShrinkClass {
      height: 0px !important;
    }
  }
}
.rollLegend {
  transform: scale(0.6);
  position: relative;
  left: 690px;
  bottom: 20px;
}
.centralTable {
  width: 50%;
  display: inline-block;
  height: 336px;
  // overflow-y: auto;
}
.workTable {
  border-left: 1px solid #ebeef5;
}
</style>
<style lang="scss">
.centralTable {
    .el-table__body-wrapper{
      height: 290px !important;
      overflow-y: auto !important;
    }
}
  
</style>
